import { Routes } from '@angular/router';
import { LeercabinePage } from './leercabine-page';

export const leercabineRoutes: Routes = [
  {
    path: '',
    component: LeercabinePage,
  },
];
